// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__7Dfky","image":"recipe_image__2_rOU","heading":"recipe_heading__1PNr5"};